import React, { Component } from 'react';
import { Form, FormGroup, Container, Label, Input, Button, Table, Modal, ModalHeader, ModalBody, Alert } from 'reactstrap';
import NavNextBack from './NavNextBack';
import GovernmentPositions from './GovernmentPositions';
import LicensesCertificates from './LicensesCertificates';
import CommunityActivities from './CommunityActivities';
import Education from './Education';
import Employment from './Employment';
import References from './References';
import Contracts from './Contracts';
import FinancialInterests from './FinancialInterests';

const components = {
    governmentPositions: GovernmentPositions,
    licensesCertificates: LicensesCertificates,
    communityActivities: CommunityActivities,
    education: Education,
    employment: Employment,
    references: References,
    contracts: Contracts,
    financialInterests: FinancialInterests
}

export default class ChildItems extends Component {
    constructor(props) {
        super(props)

        this.state = {
            governmentPositions: this.props.governmentPositions,
            communityActivities: this.props.communityActivities,
            contracts: this.props.contracts,
            education: this.props.education,
            employment: this.props.employment,
            financialInterests: this.props.financialInterests,
            licensesCertificates: this.props.licensesCertificates,
            references: this.props.references,
            item: [],
            nbrItems: 0,
            editIndex: -1,
            showTopNav: false,
            alertFailure: false
        };

    }

    static getDerivedStateFromProps(props, state) {
        if (props[props.childTable] !== state[props.childTable]) {
            return {
                [props.childTable]: props[props.childTable]
            }
        }
        return {};
    }

    componentDidMount() {
        document.addEventListener('scroll', this.trackScrolling);
    }

    componentWillUnmount() {
        document.removeEventListener('scroll', this.trackScrolling);
    }

    componentDidUpdate(prevProps, prevState) {
        let docHeight = document.body.scrollHeight;
        let windowHeight = document.documentElement.clientHeight;
        let showTopNav = docHeight > windowHeight ? true : false;

        if (prevState.showTopNav !== showTopNav) {
            this.setState({ showTopNav: showTopNav });
        }
    }

    trackScrolling = () => {
        this.setState({ showTopNav: true })
    };

    submit = (e, editIndex, editId) => {
        e.preventDefault();
        let childItems = this.state[this.props.childTable];
        let newId = this.state.nbrItems;

        if (editIndex >= 0) { 
            //editing existing values
            if (!this.props.editMode) {
                // edit array
                for (var fld in this.state.item) {
                    childItems[editIndex][fld] = this.state.item[fld];
                }
            } else {
                // save to database
                let item = this.state.item;
                item["id"] = editId;
                item["profileId"] = this.props.profiles.id;                
                fetch('api/' + this.props.childTable + '/' + editId, {
                    method: 'PUT',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ ...item })
                })
                    .then(response => {
                        if (response.ok) {
                            this.setState({ alertFailure: false })
                            this.props.updateProfile();
                        } else {
                            response.json().then(data => {
                                this.setState({ alertFailure: true })
                            })
                        }
                    }) 
            }
        } else { 
            //adding new values
            if (!this.props.editMode) {
                // edit array
                let newItem = {};
                newId = this.state.nbrItems + 1;
                newItem["id"] = newId;
                for (var field in this.state.item) {
                    newItem[field] = this.state.item[field];
                }
                childItems.push(newItem);
            } else {
                // save to database
                let item = this.state.item;
                item["profileId"] = this.props.profiles.id;
                fetch('api/' + this.props.childTable, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ ...item })
                })
                    .then(response => {
                        if (response.ok) {
                            this.setState({ alertFailure: false })
                            this.props.updateProfile();
                        } else {
                            response.json().then(data => {
                                this.setState({ alertFailure: true })
                            })
                        }
                    }) 
            }
        }

        this.setState({
            [this.props.childTable]: childItems,
            nbrItems: newId,
            item: [],
            editIndex: -1
        })
        this.toggleModal();
        this.props.updateChildItems(this.props.childTable, childItems);
    }

    edit = (id) => {
        let item = this.state.item;
        let editIndex = this.state[this.props.childTable].findIndex(g => g.id === id);
        let editedItem = this.state[this.props.childTable][editIndex];
        for (var field in editedItem) {
            item[field] = editedItem[field];
        }
        this.setState({ item: item, editIndex: editIndex, editId: id })
        this.toggleModal();
    }

    remove = (id, keyItem) => {             
            let childItems = this.state[this.props.childTable];
            let removeIndex = childItems.findIndex(g => g.id === id);
            if (removeIndex > - 1) {
                if (window.confirm("Are you sure you would like to remove the item of " + childItems[removeIndex][keyItem] + "?")) {
                    if (!this.props.editMode) {
                        //remove from array
                        childItems.splice(removeIndex, 1);
                        this.setState({ [this.props.childTable]: childItems });
                        this.props.updateChildItems(this.props.childTable, childItems);
                    } else {
                        //remove from database
                        fetch('api/' + this.props.childTable + '/' + id, {
                            method: 'DELETE'
                        })
                            .then(response => {
                                if (response.ok) {
                                    this.setState({ alertFailure: false })
                                    this.props.updateProfile();
                                } else {
                                    this.setState({ alertFailure: true })
                                }
                            })
                    }
                }
            } else {
                alert("An error occurred while removing selected item");
            }
      } 
    

    toggleModal = () => {
        if (this.state.modalOpen === true) {
            this.setState({ item: [], editIndex: -1 });
        }
        this.setState({ modalOpen: !this.state.modalOpen });
    }

    openModal = () => {
        this.toggleModal();
    }

    handleChange = (e) => {     
        let item = [];
        let allInputFields = document.querySelectorAll('form.' + this.props.childTable + ' input, textarea');
        for (var field of allInputFields) {
            item[field.name] = field.value;
        }
        this.setState({ item: item });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        switch (this.props.childTable) {
            case "governmentPositions":
                if (this.props.profiles.governmentPositions === "true" && this.props.governmentPositions.length < 1) {
                    e.stopPropagation();
                    alert("At least one Government Position must be added when 'Yes' is chosen");
                } else {
                    this.props.onClickNext();
                }
                break;
            case "licensesCertificates":
                if (this.props.profiles.licensesCertificates === "true" && this.props.licensesCertificates.length < 1) {
                    e.stopPropagation();
                    alert("At least one License or Certificate must be added when 'Yes' is chosen");
                } else {
                    this.props.onClickNext();
                }
                break;
            case "communityActivities":
                if (this.props.profiles.communityActivities === "true" && this.props.communityActivities.length < 1) {
                    e.stopPropagation();
                    alert("At least one Community Activity must be added when 'Yes' is chosen");
                } else {
                    this.props.onClickNext();
                }
                break;
            case "education":
                if (this.props.profiles.education === "true" && this.props.education.length < 1) {
                    e.stopPropagation();
                    alert("At least one Education degree must be added when 'Yes' is chosen");
                } else {
                    this.props.onClickNext();
                }
                break;
            case "employment":
                if (this.props.profiles.employment === "true" && this.props.employment.length < 1) {
                    e.stopPropagation();
                    alert("At least one Employment item must be added when 'Yes' is chosen");
                } else {
                    this.props.onClickNext();
                }
                break;
            case "references":
                if (this.props.profiles.references === "true" && this.props.references.length < 1) {
                    e.stopPropagation();
                    alert("At least one Reference must be added when 'Yes' is chosen");
                } else {
                    this.props.onClickNext();
                }
                break;
            case "contracts":
                if (this.props.profiles.contracts === "true" && this.props.contracts.length < 1) {
                    e.stopPropagation();
                    alert("At least one Contract must be added when 'Yes' is chosen");
                } else {
                    this.props.onClickNext();
                }
                break;
            case "financialInterests":
                if (this.props.profiles.financialInterests === "true" && this.props.financialInterests.length < 1) {
                    e.stopPropagation();
                    alert("At least one Financial Interest must be added when 'Yes' is chosen");
                } else {
                    this.props.handleSubmit(e);
                }
                break;
            default:
                break;
        }
    }

    returnChildFields = () => {
        let ChildComponent = components[this.props.childTable];
        return <ChildComponent item={this.state.item} onChange={(e) => this.handleChange(e)} />
    }

    onRadioChange = (e) => {
        if (e.target.value === "false" && this.props[this.props.childTable].length > 0) {
            alert("Option cannot be changed to 'No' when there is information attached to this section.")
        } else {
            this.props.onRadioChange(e);
        }
    }

    render() {
        return (
            <div>
                {this.state.showTopNav &&
                    <NavNextBack id="topNav" form={this.props.childTable} className="row justify-content-between my-1" back={this.props.back} next={this.props.next} onClickBack={this.props.onClickBack} unsavedChanges={this.props.unsavedChanges} onSaveChanges={this.props.onSaveChanges} editMode={this.props.editMode}/>
                }
                <Modal size='lg' isOpen={this.state.modalOpen} toggle={this.toggleModal} >
                    <ModalHeader toggle={this.toggleModal}>{this.props.modalHeader}</ModalHeader>
                    <ModalBody>
                        <Form id={this.props.childTable} className={this.props.childTable} onSubmit={(e) => this.submit(e, this.state.editIndex, this.state.editId)}>
                            {this.returnChildFields()}
                            <Button type='submit'>Submit</Button>
                        </Form>
                    </ModalBody>
                </Modal>

                {this.state.alertFailure &&
                    <Alert color="danger">
                    <p className="text-center font-weight-bold">An error has occurred; nothing was saved.  Please try again later.</p>
                    </Alert>
                }

                <Form id={this.props.childTable} onSubmit={this.handleSubmit}>
                    <FormGroup>
                        <Container className="form-border">
                            <FormGroup tag="fieldset">
                                <Label>{this.props.questionLabel}</Label>
                                <br />
                                <FormGroup check inline id={this.props.childTable + "Radio"} className={!this.props.profiles[this.props.childTable] ? "required-radio" : ""}>
                                    <Label check>
                                        <Input type="radio" className="includeInProgress" required name={this.props.childTable} checked={this.props.profiles[this.props.childTable] === "true"} value="true" onChange={(e) => this.onRadioChange(e)} />{' '}Yes
                                    </Label>
                                </FormGroup>
                                <FormGroup check inline>
                                    <Label check>
                                        <Input type="radio" className="includeInProgress" required name={this.props.childTable} checked={this.props.profiles[this.props.childTable] === "false"} value="false" onChange={(e) => this.onRadioChange(e)} />{' '}No
                                    </Label>
                                </FormGroup>
                            </FormGroup>
                            {(this.props.profiles[this.props.childTable] === "true" || (this.props[this.props.childTable] && this.props[this.props.childTable].length > 0)) &&
                                <div>
                                    <Button size="sm" onClick={this.openModal}>{this.props.modalHeader}</Button>
                                    <div>
                                        <Table size="sm" bordered striped className="mobile-table">
                                            <thead>
                                                <tr>
                                                    {this.props[this.props.childTable] && this.props[this.props.childTable][0] &&
                                                        Object.keys(this.props[this.props.childTable][0]).filter(o => o !== "id" && o !=="profileId").map((item, i) => {
                                                            return (
                                                                i < 5 && <th key={i}>{item.charAt(0).toUpperCase() + item.slice(1).replace(/([A-Z])/g, ' $1').trim()}</th>
                                                            )
                                                    })}
                                                    {this.props[this.props.childTable].length > 0 && <th key="action">Action</th>}                                                    
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.props[this.props.childTable] && this.props[this.props.childTable].map((row) => {
                                                    return (
                                                        <tr key={row.id}>
                                                            {Object.keys(row).filter(o => o !== "id" && o !== "profileId").map((field, i) => {
                                                                let dataTitle = field.charAt(0).toUpperCase() + field.slice(1).replace(/([A-Z])/g, ' $1').trim()
                                                                return (
                                                                    i < 5 && <td key={field} data-title={dataTitle}>{row[field]}</td>
                                                                )
                                                            })}
                                                            <td key="action">
                                                                <Button size="sm" className="mx-1" onClick={() => this.edit(row.id)}>Edit</Button>
                                                                <Button size="sm" className="mx-1" onClick={() => this.remove(row.id, this.props.keyItem)}>Remove</Button>
                                                            </td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            }
                        </Container>
                    </FormGroup>
                </Form>
                <NavNextBack id="bottomNav" form={this.props.childTable} className="row justify-content-between my-1" back={this.props.back} next={this.props.next} onClickBack={this.props.onClickBack} unsavedChanges={this.props.unsavedChanges} onSaveChanges={this.props.onSaveChanges} editMode={this.props.editMode}/>
            </div>
        )
    }
}